export const serverDomain = "https://vedas-dev.transforma.in:8443"
// export const serverDomain = "http://localhost"